<template>
  <div>
    <p class="dowimgpsps6_9" v-if="browser == true">
      如不跳转，请点击右上角，选择浏览器打开
    </p>
    <p class="dowimgpsps6_9" v-else>请稍后</p>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant";
import { shareUrl } from "../assets/js/api"
export default {
  data() {
    return {
      appDownUrl: "",
      browser: false,
      appTag:1,
    };
  },
  created() {
    document.title = "下载";
    let appTag = this.$route.query.appTag;
    this.appTag = appTag;
    this.is_weixn();
    this.getUrl()
      .then(() => {
        let url = this.appDownUrl.split(",");
        console.log("切割后的url");
        console.log(url);
        let androidUrl = url[0];
        let iosUrl = url[1];
        this.appDown(androidUrl, iosUrl);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    async getUrl() {
      let officeCode = this.$route.query.commendCode;
      let appTag = this.appTag;
      await axios
        .post("/common/v1/bannerH5Log", {
          officeCode,appTag
        })
        .then((res) => {
          console.log("获取的地址");
          console.log(res);
          this.appDownUrl = res.data.appDownUrl;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 判断是不是微信浏览器
    is_weixn(androidUrl, iosUrl) {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.browser = true;
        return true;
      } else {
        return false;
      }
    },
    appDown(androidUrl, iosUrl) {
      var ua = navigator.userAgent;
      var isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //g
      var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        if (androidUrl == "") {
          Toast("数据加载失败，请稍后尝试");
        } else {
          window.location.href = androidUrl;
        }
      } else if (isiOS) {
        if (iosUrl == "") {
          Toast("数据加载失败，请稍后尝试");
        } else {
          window.location.href = iosUrl;
        }
      }
    },
  },
};
</script>

<style scoped>
.dowimgpsps6_9 {
  width: 100%;
  text-align: center;
  color: #999;
  float: left;
  margin-top: 40vh;
}
</style>